<template lang="html">
    <div id="page__status-reasons" class="center-panel">
        <md-content md-theme="white" class="md-elevation-1" v-loader-overlay="progress">
            <sort-table
                v-bind:columns="tableColumns" v-model="reasons" @refresh="getReasons" v-bind:per-page="perPage" 
                v-bind:total="reasonAmount" table-id="reasons" ref="table" v-on:create="addReason" link
            >
                <template slot="comment_require" slot-scope="scope">
                    <span> {{ (scope.item.comment_require && parseInt(scope.item.comment_require) === 1) ? 'Да' : 'Нет' }} </span>
                </template>

                <template slot="status_id" slot-scope="scope">
                    <span v-if="scope.item.status" v-bind:style="'color: ' + scope.item.status.color + ';'"> {{ scope.item.status.name }} </span>
                </template>

                <template slot="actions" slot-scope="scope">
                    <z-icon-button v-bind:icon="['fa', 'trash']" danger-light  rounded v-on:click.stop.prevent="onRemove(scope.item.id)"></z-icon-button>
                </template>
            </sort-table>
        </md-content>
    </div>
</template>
<script>
    import SortTable   from '@/components/SortTable';
    import ZIconButton from '@/components/ZIconButton';
    export default {
        components: { SortTable, ZIconButton },
        data() {
            return {
                perPage: 50,
                tableColumns: [
                    { label: 'ID', field: 'id', sortable: true },
                    { label: 'Название', field: 'name', sortable: true},
                    { label: 'Код', field: 'code'},
                    { label: 'Наличие комментария обязательно',  field: 'comment_require', sortable: true},
                    { label: 'Статус',   field: 'status_id', sortable: true},
                    { label: '', field: 'actions' },
                ],
                title: 'Признаки статусов заявок'
            }
        },
        computed: {
            /**
             * Список признаков
             */
            reasons() {
                return !this.$store.state.deals.statusreasons ? [] : this.$store.state.deals.statusreasons.map(reason => {
                    reason.routerLink = { name: 'StatusReason', params: { reason_id: reason.id }, query: this.$route.query };
                    return reason;
                });
            },
            /**
             * Количество признаков
             */
            reasonAmount() {
                return this.$store.state.deals.statusreasons_amount
            },
            /**
             * Флаг загрузки текущего компонента
             */
            progress() {
                return this.progressObj['get-status-reasons-list'];
            },
            /**
             * Объект с флагами загрузки
             */
            progressObj() {
                return this.$store.state.progressObj;
            },
        },
        created() {
            this.$store.commit('setTitle', this.title);
        },
        methods: {
            /**
             * Добавление признака
             */
            addReason() {
                this.$router.push({ name: 'StatusReason', params: { reason_id: 'new' } });
            },
            /**
             * Получение Признаков
             */
            getReasons(page, count, orderBy, orderType) {
                this.$store.commit('showProgressBar', 'get-status-reasons-list');
                return this.$store.dispatch('deals/getStatusReasons', {
                    page: page, order_by: orderBy, order_type: orderType, count: count
                }).finally(() => this.$store.commit('hideProgressBar', 'get-status-reasons-list'));
            },
            /**
             * Удаление признака
             */
            removeReason(id) {
                this.$store.commit('showProgressBar', 'get-status-reasons-list');
                this.$store.dispatch('deals/deleteStatusReason', id)
                    .then(() => this.$root.$emit('refresh-table', 'reasons'))
                    .finally(() => this.$store.commit('hideProgressBar', 'get-status-reasons-list'))
            },
            /**
             * Модальное окно с удалением признака
             */
            onRemove(id) {
                this.$root.$emit(
                    'z-alert', 'Вы уверены в удалении признаки', 'Действие необратимо!',
                    () => this.removeReason(id)
                )
            },
        },
    }
</script>


// WEBPACK FOOTER //
// StatusReasons.vue?67a8e7f6